import { Box, withStyles } from '@material-ui/core';

export const PaginationWrapperBox = withStyles(({ spacing }) => ({
  root: {
    marginTop: spacing(2),
  },
}))(Box);
